import { render, staticRenderFns } from "./marketCodeProduct.vue?vue&type=template&id=25fdb2a5&"
import script from "./marketCodeProduct.vue?vue&type=script&lang=js&"
export * from "./marketCodeProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports